import React from "react";
import { Link } from "react-router-dom";
import { t } from "@miezmission/i18n";

const translations = t("de");

export function HomePage(): React.ReactElement {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6 gap-6">
      <div className="text-center">
        <div className="text-7xl mb-4">🐱</div>
        <h1 className="text-3xl font-bold text-purple-700 mb-2">MiezMission</h1>
        <p className="text-gray-500 text-sm">Familienroutinen mit Katzenfaktor</p>
      </div>

      <div className="w-full max-w-sm space-y-3">
        <Link
          to="/pet"
          className="block w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-3 px-6 rounded-2xl text-center transition-colors"
        >
          {translations.buttons.viewPet}
        </Link>
        <button
          className="w-full bg-white border-2 border-purple-200 hover:border-purple-400 text-purple-700 font-semibold py-3 px-6 rounded-2xl transition-colors"
          onClick={() => { console.info("Add routine"); }}
        >
          {translations.buttons.addRoutine}
        </button>
      </div>
    </div>
  );
}
